/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/**
 * bam-import.module.ts
 * 29-04-2024 - Jelmer Jellema - Spin in het Web B.V. Apeldoorn NL
 * Module voor component BamimportScherm
 * Selector: bam-import
 */

import {NgModule} from '@angular/core';
import {BamimportScherm} from './bam-import';
import {MdatepipeModule} from 'sihw-ng/pipes/mdate/mdatepipe.module';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';

@NgModule({
  declarations: [BamimportScherm],
  imports: [
    CommonModule,
    MdatepipeModule,
    FormsModule
  ],
  exports: [BamimportScherm]
})
export class BamimportSchermModule {
}
BamimportScherm.register('Bamimportscherm');
